module.exports = __webpack_public_path__ + "img/chiral_footer_logo.3f365987.png";